import { CatGridItem } from 'blocks-nextjs/blocks-react/components/GridItem';
import { useTranslations } from 'next-intl';
import ContactYourDealerPopover from 'components/contact-your-dealer/contact-your-dealer-popover/contact-your-dealer-popover';

const StoreAvailabilityContactDealer = ({ contactDealer, address }) => {
  const t = useTranslations();
  return (
    <CatGridItem className="mt-3">
      <div className="d-flex">
        <div className="fw-bold pr-1 pe-1">{contactDealer?.quantity}</div>
        <ContactYourDealerPopover
          dealerAddress={address}
          variant="inline"
          className="d-inline-block"
          size="md"
          msg={contactDealer?.message}
          shouldFitContent
        />
      </div>
      <div className="fst-italic">
        {t('PDP_AVAILABILITY_ADDITIONAL_DEALER_INFO')}
      </div>
    </CatGridItem>
  );
};

export default StoreAvailabilityContactDealer;
